export default __webpack_public_path__ + "static/media/02_anis.7f7a07b5.gif";